import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <div className="page-shell">
      <div className="container detail-container">
        <div className="card auth-panel">
          <p className="eyebrow">404</p>
          <h1 className="page-heading">Page not found</h1>
          <p className="page-copy">
            The page you tried to open does not exist or may have been moved.
          </p>
          <div className="hero-actions">
            <Link to="/" className="btn btn-primary">Go home</Link>
            <Link to="/archive" className="btn btn-secondary">Browse archive</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;